import { ALLOCATIONS_DRAFT, ALLOCATIONS_FINAL, ALLOCATIONS_PUBLISHED } from 'common/constants/allocations';

export const ALLOCATION_STATUS = {
  [ALLOCATIONS_DRAFT]: 'Draft',
  [ALLOCATIONS_PUBLISHED]: 'Published',
  [ALLOCATIONS_FINAL]: 'Final',
};
